require('../bootstrap');
require('../directives');
require('../filters');

import PortalVue from 'portal-vue';
Vue.use(PortalVue);

import Gtag from '../src/core/Gtag';
import Media from '../src/mixins/Media';

import * as Components from './components';

new Vue({
  mixins: [Media],
  components: {
    ...Components,
  },
  data: {
    search: {
      opened: false,
    },
  },
  mounted() {
    if (
      this.$el.children[1] &&
      this.$el.children[1].classList.contains('slide-show')
    ) {
      this.$el.classList.add('has-slide-show');
    }
    window.addEventListener('click', event =>
      EventBus.fire('body-clicked', event)
    );
    new Gtag();
  },
  methods: {
    backgroundImage(paths) {
      return {
        backgroundImage: "url('" + paths[this.media] + "')",
      };
    },
  },
}).$mount('#app');
